/* eslint-disable import/prefer-default-export */
import { platformSwitch } from '../../configuration';

import * as web from './web';
import * as native from './native';

export const { initGtm } = platformSwitch({ web, native });
